export const ANONYMOUS_LAYOUT_ROUTE_CONFIG = {
  hideHeader: false,
  skipAuth: true,
};

export const MARKETPLACE_LANDING_FILTER_FORM = 'MarketplaceLandingFilterForm';
export const SIDEBAR_RESOURCES_FILTER_FORM = 'SidebarResourcesFilterForm';
